/**
 * Created by dx.yang on 2017/2/22.
 */


import Vue from 'vue';
export default {
    name: 'KsTableAdvBody',
    props: {
        store: null
    },

    methods: {
        checkRow(e, row, eventOnCheckbox) {
            // todo: clipboard
            e.stopPropagation();
            // e.preventDefault();
            if (this.store.states.select.enabled) {
                this.store.commit('checkRow', {
                    row,
                    eventOnCheckbox
                });
            }
            return false;
        },
        hoverTr(e, row, evName) {
            this.store.table.$emit('tr-mouse' + evName, {
                e, row
            });
        }
    },
    render(h) {
        let states = this.store.states;
        let cols = states.columns;
        let rows = states.rows2show || [];

        let tbodyContent;
        if (rows.length) {
            tbodyContent = (
                <tbody>
                {
                    rows.map((r, idx) => {

                        let classes = 'ks-table-new-style-checkbox';
                        if (states.checkedList.indexOf(r) != -1) {
                            classes += ' be-checked';
                        }

                        return (
                            <tr on-click={ (e) => { this.checkRow(e, r) } }
                                on-mouseover={ (e) => { this.hoverTr(e, r, 'over') } }
                                on-mouseout={ (e) => { this.hoverTr(e, r, 'out') } }
                            >
                                {
                                    states.select.enabled && <td>
                                        <div class={classes} on-click={ (e) => { this.checkRow(e, r, true) } }>
                                            <div class="inner-checkbox">
                                                <div class="inner-checkbox-dot"></div>
                                            </div>
                                        </div>
                                    </td>
                                }
                                {
                                    cols.map(c => {
                                        return (
                                            <td>
                                                {
                                                    c.template && c.template({
                                                        row: r,
                                                        $idx: idx
                                                    })
                                                }
                                            </td>
                                        );
                                    })
                                }
                            </tr>
                        )
                    })
                }
                </tbody>
            );
        } else {
            let colsSize = cols.length;
            if (states.select) {
                colsSize += 1;
            }
            let tip = <span>/(ㄒoㄒ)/~~ {Vue.$trans(`没有找到亲要的数据哦~`)}</span>;
            if (states.loading) {
                tip = <span><i class="fa fa-spinner fa-spin"></i> {Vue.$trans(`正在加载`)}...</span>
            }
            tbodyContent = (
                <tbody>
                <tr class="tip-tr">
                    <td colspan={colsSize}>
                        {tip}
                    </td>
                </tr>
                </tbody>
            );
        }

        return (
            <table class="ks-table">
                <colgroup>
                    {
                        states.select.enabled && <col width="25" />
                    }
                    {
                        cols.map(c => <col width={c.realWidth} />)
                    }
                    {
                        <col />
                    }
                </colgroup>
                {tbodyContent}
            </table>
        );
    }
};
